import React, { useEffect, useState, useRef } from "react";
import { Button, Typography } from "@material-ui/core";
import localforage from "localforage";
import { useTranslation } from "../../langs/useTranslation";
import CompanyTreeModal from "./Modal";
import { ArrowDropDown } from "@material-ui/icons";
import { getAccountInfo } from "@/apis/apiCollection";
import { setUserInfo } from "@/apis/getUserInfo";

function getCompanyMap() {
  return JSON.parse(sessionStorage.getItem("companiesMap") || "{}");
}

const CompanySelector = ({ onSelect, companyId }) => {
  const [companyTreeModalOpen, setCompanyTreeModalOpen] = useState(false);
  const [companyName, setCompanyName] = useState(() => {
    return getCompanyMap()[companyId] || "";
  });
  const bc = useRef(null);
  const { t } = useTranslation();

  const handleClick = () => {
    setCompanyTreeModalOpen(true);
  };

  const handleClose = () => setCompanyTreeModalOpen(false);

  const handleCompanySelect = async (selectedKey, selectedNode) => {
    if (selectedKey.length === 0) return
    const { user } = await getAccountInfo({ company_id: selectedKey[0] });
    await localforage.setItem("user", user);
    // await localforage.setItem("token", response.data.token);
    // await localforage.setItem("expiredAt", response.data.expires_at);
    // await localforage.setItem("companyId", user?.company_id);
    // await localforage.setItem("companyName", user?.company?.name);
    await localforage.setItem("currentCompanyId", user.company?.id);
    await localforage.setItem("currentCompanyName", user.company?.name);
    setCompanyName(selectedNode.node.name);
    setUserInfo(user);
    handleClose();
    onSelect?.(selectedKey, selectedNode);
    const prevCompanyMap = getCompanyMap();
    sessionStorage.setItem(
      "companiesMap",
      JSON.stringify({
        ...prevCompanyMap,
        [selectedKey[0]]: selectedNode.node.name
      })
    );
    bc.current?.postMessage("test");
  };

  const syncCompanyName = companyId => {
    if (companyId) {
      const name = getCompanyMap()[companyId] || "";
      if (name) {
        setCompanyName(name);
      } else {
        localforage.getItem("currentCompanyName").then(setCompanyName);
      }
    } else {
      localforage.getItem("currentCompanyName").then(setCompanyName);
    }
  };

  useEffect(() => {
    syncCompanyName(companyId);
  }, [companyId]);

  useEffect(() => {
    bc.current = new BroadcastChannel("currentCompanyId");

    bc.current.onmessage = () => {
      syncCompanyName();
    };

    return () => {
      bc.current?.close();
    };
  }, []);

  return (
    <>
      <Button endIcon={<ArrowDropDown />} onClick={handleClick}>
        <Typography variant="button">
          {companyName || t({ defaultMessage: "选择公司" })}
        </Typography>
      </Button>
      <CompanyTreeModal
        open={companyTreeModalOpen}
        companyId={companyId}
        checkable={false}
        footer={null}
        onClose={handleClose}
        onSelect={handleCompanySelect}
      />
    </>
  );
};

export default CompanySelector;
